module.exports = __webpack_public_path__ + "static/cameron-mendes-0cdb68762afc9b2d622537a6999b0137.jpg";